import { createContext } from 'react';

const ModalContext = createContext({
  attachModal: (_) => {},
  detachModal: (_) => {}
});

export default ModalContext;
